import Immutable from 'immutable';
import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import Checkbox from '@bibliocommons/base-checkbox';
import { InlineOverlay, InlineOverlayHeader, InlineOverlayFooter, InlineOverlayBody, InlineOverlayCloseButton } from '@bibliocommons/base-inline-overlay';
import { TextButton, PrimaryButton } from '@bibliocommons/base-buttons';
import { Checkmark, Info } from '@bibliocommons/base-icons';
import { GenericForm } from '@bibliocommons/shared-messages';
import HoldInfoMessages from '@bibliocommons/shared-hold-info-messages';
import PickupBranchSelect from '@bibliocommons/shared-pickup-branch-select';

import { MATERIAL_TYPE_PHYSICAL } from '../../../../../../constants/BibConstants';
import MessagingContainer from '../../../../../../containers/shared/Messaging/MessagingContainer';
import BibBrief from '@bibliocommons/shared-bib-brief';

import '../styles/PhysicalHoldsWorkflowView.scss';

class PhysicalHoldsWorkflowView extends BcReactComponent {
  constructor(props) {
    super(props);

    this.state = {
      pickupLocation: props.branches.size === 1 ? props.branches.first() : props.branches.find(b => b.get('code') === props.preferredBranch) || Immutable.Map(),
      singleClickHoldsEnabled: false,
      expiryDate: null,
      singleClickHoldsInfoOpen: false
    };

    this.bindAll('handlePlaceHold', 'handleUpdatePickupLocation', 'handleUpdateSingleClickHolds', 'handleClickInfoButton');
  }

  handlePlaceHold() {
    this.props.placeHold({
      workflowId: this.props.workflowId,
      messagingId: this.props.messagingId,
      accountId: this.props.accountId,
      metadataId: this.props.bib.get('id'),
      materialType: MATERIAL_TYPE_PHYSICAL,
      enableSingleClickHolds: this.state.singleClickHoldsEnabled,
      materialParams: {
        branchId: this.state.pickupLocation.get('code'),
        expiryDate: null,
        errorMessageLocale: this.props.currentLocale
      }
    });
  }

  handleUpdatePickupLocation(pickupLocation) {
    this.setState({
      pickupLocation
    });
  }

  handleUpdateSingleClickHolds(value) {
    this.setState({
      singleClickHoldsEnabled: value
    });
  }

  handleClickInfoButton() {
    this.setState({
      singleClickHoldsInfoOpen: !this.state.singleClickHoldsInfoOpen
    });
  }

  renderSingleClickHoldsInfo() {
    if (this.state.singleClickHoldsInfoOpen) {
      return (
        <div className="text-left single-click-holds-info">
          <FormattedMessage id="single_click_holds_enable_desc" tagName="p" />
        </div>
      );
    }

    return <noop />;
  }

  render() {
    const { handleClose, bib, branches, holdInfoMessages, isLoading } = this.props;
    return (
      <InlineOverlay handleClose={handleClose} data-test-id={`physical-holds-overlay-${bib.get('id')}`}>
        <InlineOverlayHeader>
          <FormattedMessage id="section_title_request_hold" />
        </InlineOverlayHeader>
        <InlineOverlayBody>
          <MessagingContainer id={bib.get('id')}>{messageOptions => <GenericForm {...messageOptions} />}</MessagingContainer>
          <BibBrief bib={bib} titleTag="h3" renderTitleAsLink={false} renderAuthorsAsLink={false} />
          <HoldInfoMessages messageIds={holdInfoMessages} />
        </InlineOverlayBody>
        <InlineOverlayFooter>
          <form className="form-horizontal">
            <div className="branch-select-column">
              <div className="clearfix">
                {branches.size > 1 && (
                  <PickupBranchSelect
                    fieldErrors={this.props.fieldErrors}
                    branches={branches}
                    label="Pickup at"
                    handleSelect={this.handleUpdatePickupLocation}
                    selectedBranch={this.state.pickupLocation.get('code')} />
                )}
              </div>

              <div className="text-left enable-single-click-holds-wrap">
                <Checkbox
                  label={<FormattedMessage id="single_click_holds_enable_title" />}
                  id={`enable-single-click-holds-${bib.get('id')}`}
                  checked={this.state.singleClickHoldsEnabled}
                  handleChange={this.handleUpdateSingleClickHolds} />
                <TextButton className="help-info" handleClick={this.handleClickInfoButton}>
                  <Info />
                  <FormattedMessage id="label_info" />
                </TextButton>
              </div>
            </div>
            <div className="holds-action-column">
              <PrimaryButton className="pull-right" isLoading={isLoading} handleClick={this.handlePlaceHold} data-test-id={`submit-place-hold-${bib.get('id')}`}>
                <Checkmark color="#FFF" />
                &nbsp;
                <FormattedMessage id="button_confirm_hold" />
              </PrimaryButton>
              <InlineOverlayCloseButton className="btn btn-link pull-right">
                <FormattedMessage id="button_nevermind_close" />
              </InlineOverlayCloseButton>
            </div>
            {this.renderSingleClickHoldsInfo()}
          </form>
        </InlineOverlayFooter>
      </InlineOverlay>
    );
  }
}

PhysicalHoldsWorkflowView.displayName = 'PhysicalHoldsWorkflowView';
PhysicalHoldsWorkflowView.propTypes = {
  handleClose: PropTypes.func.isRequired,
  fieldErrors: PropTypes.objectOf(
    PropTypes.shape({
      classification: PropTypes.string,
      message: PropTypes.string
    })
  ),
  bib: ImmutablePropTypes.map,
  branches: PropTypes.arrayOf(ImmutablePropTypes.map).isRequired,
  preferredBranch: PropTypes.string,
  placeHold: PropTypes.func.isRequired,
  accountId: PropTypes.number.isRequired,
  currentLocale: PropTypes.string.isRequired,
  holdInfoMessages: PropTypes.arrayOf(PropTypes.number),
  isLoading: PropTypes.bool,
  renderMessage: PropTypes.func.isRequired,
  workflowId: PropTypes.string,
  messagingId: PropTypes.string
};

export default PhysicalHoldsWorkflowView;



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/physical-holds-workflow-view/components/PhysicalHoldsWorkflowView.component.jsx